import React from 'react';

import {Icon, IconData} from '@gravity-ui/uikit';

import {block} from '../cn';

import {invertHex, strToHexMemoized} from './colorize';

import orgIcon from '../../../assets/icons/org.svg';

import './OrganizationIcon.scss';

const b = block('organization-icon');

export interface OrganizationIconProps {
    orgId: string;
    className?: string;
    size?: number;
    icon?: IconData;
    iconSize?: number;
}

export const OrganizationIcon: React.FC<OrganizationIconProps> = ({
    orgId,
    className,
    size,
    icon,
    iconSize,
}) => {
    const backgroundColor = strToHexMemoized(orgId);
    const color = invertHex(backgroundColor);
    return (
        <div
            className={b(null, className)}
            style={{
                color,
                backgroundColor,
                width: `${size}px`,
                height: `${size}px`,
            }}
        >
            <Icon data={icon ? icon : orgIcon} size={iconSize || '100%'} />
        </div>
    );
};
